import React, {useState, useEffect, useRef, useContext} from 'react'
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import useModal from './useModal'

// import history from '../../history'
import Modal from './Modal'
import './Nav.scss'
import { UserContext } from '../../context/context';

import {isSafari} from 'react-device-detect';

// Hook

function useHover() {
  const [value, setValue] = useState(false);
  const ref = useRef(null);
  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);
  
  

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener("mouseover", handleMouseOver);
        node.addEventListener("mouseout", handleMouseOut);
        return () => {
          node.removeEventListener("mouseover", handleMouseOver);
          node.removeEventListener("mouseout", handleMouseOut);
        };
      }
    },
    [ref.current] // Recall only if ref changes
  );
  return [ref, value];
}

function Nav(props) {
  const highlight = "rgb(60, 60, 60)"
  
  const [state, actions] = useContext(UserContext);
  

  const [hoverRef, isHovered] = useHover();
  const [hoverRef2, isHovered2] = useHover();

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))

  // const [whoru, setWhoru] = useState(null)
  const [school, setSchool] = useState(null)

  const dropdownRef = useRef(null);

  const [isActive, setIsActive] = useState(false);
  
  const history = useHistory()

  useEffect(()=>{
    console.log(history.location)
    console.log(window.location)
    // history.listen(prevLocation => {
    //   console.log(prevLocation);
    // });
    actions.setIsShowing(false)
  }, [isActive])

  // const {isShowing, setIsShowing} = useModal();

 
  // console.log(isHovered)
  // console.log(whoru)
  // console.log(user.user["username"])
  // console.log(state.user)
  console.log(user)
  return(
    <>
    {/* {state.width < state.breakpoint ? 
     null
    : */}
    <SideMenuLeft>
          <div>
              <div 
                style={{backgroundColor:"rgba(0,0,0,0)"}}>
                  <Link to={{pathname: '/', state: { prevPath: history.location.pathname }  }}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/images/logo_test.png"}
                    />
                    </Link>
                  
              </div>

              <div 
              
                style={window.location.pathname ==='/quration' ? {backgroundColor:highlight}: {}} ref={hoverRef}
                >
                  <Link to={{pathname: '/quration', state: { prevPath: history.location.pathname }  }} >
                    큐레이션
                  </Link>
                  
                  {/* <span className={isHovered? "presentation": "default"}>

                    {isHovered? "가": null}

                  </span> */}
              </div>
              
              <div 
                style={window.location.pathname.split('/')[1] ==='ralist' ? {backgroundColor:highlight}: {}} 
                ref={hoverRef2}>
                  {/* <div> */}
                  <Link 
                    to={{pathname: '/ralist', state: { prevPath: history.location.pathname }  }}
                  >
                    채용
                      {/* <img src={resource_url+'table.png'}/> */}
                  </Link>

                  <span className={isHovered2? "presentation": "default"}>
                    {isHovered2? "나": null}
                  </span>
                  {/* </div> */}

              </div>

              <div 
                style={window.location.pathname ==='/resume' ? {backgroundColor:highlight}: {}}>
                  <Link to={{pathname: '/resume', state: { prevPath: history.location.pathname } }}>
                    이력서
                      {/* <img src={resource_url+'table.png'}/> */}
                  </Link>

                  
              </div>

              <div 
                style={window.location.pathname ==='/companynlab' ? {backgroundColor:highlight}: {}}>
                  <Link to={{pathname: '/companynlab', state: { prevPath: history.location.pathname } }}>
                    기업/LAB
                      {/* <img src={resource_url+'table.png'}/> */}
                  </Link>
              </div>
              
              <div 
                style={window.location.pathname ==='/event' ? {backgroundColor:highlight}: {}}>
                  <Link to={{pathname: '/event', state: { prevPath: history.location.pathname } }}>
                    이벤트
                      {/* <img src={resource_url+'table.png'}/> */}
                  </Link>
              </div>

              <div>
                  {user ?
                  <>
                    <span className={"menu-container"}onClick={()=>setIsActive(!isActive)}>{user.user ? user.user["username"] : email}
                      <nav ref={dropdownRef} className={`menu ${isActive ? 'active' : 'inactive'}`}>
                        <ul>
                          <li><Link to="/dashboard">My Qurator</Link></li>
                          <li><Link to="/profile">Profile</Link></li>
                          <li><Link to="/applylist">지원현황</Link></li>
                          <li><Link to="/proposallist">제안현황</Link></li>
                          <li><a onClick={()=>{props.logout(); actions.setToken(null); actions.setUser({})}}>Log out</a></li>
                        </ul>
                      </nav>
                    </span>
                    
                    <Link to={{pathname: '/messages', state: { prevPath: history.location.pathname } }}>
                      메세지
                    </Link>

                  </>
                  :
                  <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
                    로그인
                  </button>
                  }
                  
              </div>
              

              <div 
                // style={window.location.pathname ==='/recruiter' ? {backgroundColor:highlight}: {}}
                >
                  <Link to={{pathname: '/recruiter', }}>
                    <button >
                      기업회원
                    </button>
                  </Link>
              </div>

              
          </div>
          {user ?
          null
          :<Modal
            isShowing={state.isShowing}
            hide={()=>actions.setIsShowing(!state.isShowing)}
            // logout={props.logout}
          />}

      </SideMenuLeft>
    {/* } */}
      
    </>  
  )
}


const LoginDiv = styled.div`

`
const SideMenuLeft = styled.div`
  
  display:flex;
  align-items: flex-start;
  justify-content: center;

  position: fixed;
  left: 0px;
  top: 0px;
  height: calc(45px);
  /* @media (max-width: 1024px){
    width: 0;
  } */
  /* width: 250px; */
  
  width: 100vw;
  background-color: rgba(0, 0, 0, .8);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: 4;

  -ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; -khtml-user-select: none; user-select:none;

  transition: .2s;

  /* img{
      width: 30px;
  } */

  >div{
      width: 90%;
      max-width: 1060px;
      /* left:20vw; */
      /* position: absolute; */
      display: flex;
      height: 100%;
      /* border: solid white; */
        /* flex-direction: column; */
      align-items: center;
      justify-content: center;

      div{
        width: 100%;
        height: 100%;

        color: whitesmoke;

        transition: .2s;
        font-size: .8rem;

        display: flex;
        align-items: center;
        justify-content: center;
        /* :active{
            background-color: rgba(50, 50, 50, 1);
        }; */

        :hover{
            /* background-color: rgba(50, 50, 50); */
        }
        
        > a{
            color: whitesmoke;
            text-decoration: none;
            height: 100%;
            z-index: 3;
            display: flex;
            align-items: center;
            
            text-align: center;
            white-space: nowrap;
        }

        button, button:focus, button:active {
            color: whitesmoke;
            background-color: rgba(0,0,0,0);
            border: whitesmoke solid 1px;
            border-radius: 10px;

            text-decoration: none;
            height: 60%;
            z-index: 3;
            display: flex;
            align-items: center;
            
            text-align: center;

            outline:none;
            cursor: pointer;
        }
        :first-child{
          color: whitesmoke;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          /* height: 50px; */

          font-size: 1rem;
          box-sizing: border-box;
          padding-left: 10px;
          padding-right: 10px;
          img{
            width: 100px;
          }
        }

        

        :nth-last-child(2){
          display: flex;
          /* align-items: flex-end; */
          justify-content: flex-end;
          margin-left: 30px;
          >a{
            margin-left: 20px;
          }
        }

        :last-child{
          display: flex;
          align-items: center;
          justify-content: flex-end;
          box-sizing: border-box;
          padding-right: 10px;
        }
      }
      
  }
`

const Detail = styled.div`
  position:absolute;
  top: 45px;
  /* width: 500px;
  height: 500px; */
  height: 0;
  /* color: black; */
  background-color: rgba(0, 0, 0, .7);
`

export default Nav;